import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function submittedAssetsReducer(
  state = initialState.submittedAssets,
  action
) {
  //avoiding state mutation, while updating nested states.
  switch (action.type) {
    case types.SET_SUBMITTED_ASSETS:
      return action.data;
    case types.RESET_SUBMITTED_ASSETS:
      return [];
    default:
      return state;
  }
}
